export function resolveHistoryStartIndex(list, { alignToJanuary = true, historyMonths = null } = {}) {
    const length = Array.isArray(list) ? list.length : 0;
    if (!length) {
        return 0;
    }
    if (!alignToJanuary && historyMonths) {
        return Math.max(0, length - historyMonths);
    }
    const janStartIndex = list.findIndex((item) => String(item?.monthYear || '').includes('/01'));
    return janStartIndex === -1 ? 0 : janStartIndex;
}

export function sliceTail(items, count) {
    if (!count || !Array.isArray(items)) {
        return items;
    }
    return items.slice(-count);
}

export function xAxisTickEveryForMonths(months) {
    const n = Number(months) || 60;
    if (n <= 6) {
        return 1;
    }
    if (n <= 12) {
        return 3;
    }
    return 12;
}
